<template>
  <div :class="[isfold ? 'fold' : 'unfold', 'alpha-collapse']">
    <p class="company-type-title">
      <slot name="header"></slot>
      <span style="flex-grow:1">
        <i
          :class="[isfold ? '' : 'rotate', 'el-icon-arrow-right']"
          style="display:inline-block;float: right;color:#409eff"
          @click="toggle"
        />
      </span>
    </p>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    fold: { type: Boolean, default: true },
    height: { type: [String, Number], default: '300px' },
  },
  data() {
    return {
      isfold: true,
    }
  },
  mounted() {
    this.isfold = this.fold
  },
  methods: {
    toggle() {
      this.isfold = !this.isfold
      this.$emit('heightChange')
    },
  },
}
</script>
<style scoped>
.fold {
  max-height: 34px;
}
/* .unfold {
  max-height: 300px;
} */
.company-type-title {
  display: flex;
  align-items: center;
}
.alpha-collapse {
  transition: 0.5s ease all;
  overflow: hidden;
}
.rotate {
  transform: rotate(90deg);
}
</style>
